import { render } from "./Affirmations.vue?vue&type=template&id=3e2d6c0b&scoped=true"
import script from "./Affirmations.vue?vue&type=script&lang=js"
export * from "./Affirmations.vue?vue&type=script&lang=js"

import "./Affirmations.vue?vue&type=style&index=0&id=3e2d6c0b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2d6c0b"]])

export default __exports__